import React from "react";
import { STATUS_LABELS } from "@/components/Status";

/** Reverse-chronological status history. */
export default function OrderTimeline({ history }) {
  const items = (history || []).slice().reverse();
  return (
    <div className="surface-card p-6">
      <div className="overline">Timeline</div>
      <ul className="mt-4 space-y-3 text-sm">
        {items.length === 0 && (
          <li className="text-[#7A7A7A]">No history yet.</li>
        )}
        {items.map((h) => (
          <li key={`${h.status}-${h.at}`} className="flex items-start gap-3">
            <span className="stepper-dot is-done mt-1 flex-shrink-0" />
            <div>
              <div className="font-medium text-[#1A1A1A]">{STATUS_LABELS[h.status] || h.status}</div>
              <div className="text-xs text-[#7A7A7A]">{new Date(h.at).toLocaleString()}</div>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
